import { inject, Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';

@Pipe({
  name: 'userInitials',
})
export class UserInitialsPipe implements PipeTransform {
  private readonly userService = inject(UserService);

  async transform(userId: string): Promise<string> {
    if (!userId) return '?';

    const user = await this.userService.getUserById(userId).catch(() => null);

    if (!user) return '?';

    const displayName = user.user.human?.profile?.displayName || user.user.username || '';
    return this.getInitials(displayName);
  }

  private getInitials(name: string): string {
    if (!name) return '?';

    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .substring(0, 2);
  }
}
